var data = [
  {
    id: 1,
    restaurant_name: "Bondi&Bourke Davao",
    longitude: 7.067931,
    latitude: 125.606092,
    logo_url: "",
    address: "115 P Pelayo St, Poblacion District, Davao City, 8000 Davao del Sur",
    contact: "0998 593 3763",
    tags: [
      {
        name: "Pasta",
      },
      {
        name: "Pork Belly"
      }
    ]
  },
  {
    id: 2,
    restaurant_name: "Tsuru Japanese Restaurant And Sushi Bar",
    longitude: 7.101852,
    latitude: 125.632500,
    logo_url: "",
    address: "Zone C Unit C3 Damosa Gateway, Mamay Road, Lanang, Davao City, 8000",
    contact: "",
    tags: [
      {
        name: "Japanese",
      },
      {
        name: "Pasta"
      },
      {
        name: "Sushi"
      },
      {
        name: "Beer"
      }
    ]
  },
  {
    id: 3,
    restaurant_name: "Surf & Turf Davao",
    longitude: 7.101086,
    latitude: 125.632973,
    logo_url: "",
    address: "Klm 7, JP Laurel Ave. in Lanang Fronting NCCC Choice Mart Damosa, Lanang, Davao City, 8000 Davao del Sur",
    contact: "0946 337 8670",
    tags: [
      {
        name: "Crabs",
      },
      {
        name: "Shrimps"
      },
      {
        name: "Ribs"
      },
      {
        name: "Chicken"
      }
    ]
  },
  {
    id: 4,
    restaurant_name: "Blue Post Boiling Crabs and Shrimps",
    longitude: 7.099389,
    latitude: 125.626204,
    logo_url: "",
    address: "Branch1: In Between SM Lanang and Dcwd Branch2: Lanang Business Park, Mindanao 8000,, Dabaw, Lalawigan ng Davao del Sur",
    contact: "(082) 221 8360",
    tags: [
      {
        name: "Crabs",
      },
      {
        name: "Shrimps"
      }
    ]
  },
  {
    id: 5,
    restaurant_name: "Penong's Lanang",
    longitude: 7.101025,
    latitude: 125.631386,
    logo_url: "",
    address: "J.P. Laurel Avenue (In front of Toyota Motors), Lanang, Davao City, Davao del Sur",
    contact: "(082) 234 9718",
    tags: [
      {
        name: "Chicken",
      },
      {
        name: "Grill"
      },
      {
        name: "Unlimited Rice"
      }
    ]
  },
  {
    id: 6,
    restaurant_name: "Nadri Korean Restaurant",
    longitude: 7.102149,
    latitude: 125.632434,
    logo_url: "",
    address: "Damosa Gateway, Lanang, Davao City, 8000 Davao del Sur",
    contact: "0946 552 2270",
    tags: [
      {
        name: "Korean",
      },
      {
        name: "Pasta"
      }
    ]
  },
  {
    id: 7,
    restaurant_name: "YELLOW CAB Pizza Co.",
    longitude: 7.101808,
    latitude: 125.632729,
    logo_url: "",
    address: "Damosa Gateway, Corner Mamay Road, JP. Laurel Avenue, Barangay. Angliongto, Lanang, Davao City, 8000 Davao del Sur",
    contact: "(082) 235 3333",
    tags: [
      {
        name: "Korean",
      },
      {
        name: "Pasta"
      }
    ]
  },
  {
    id: 7,
    restaurant_name: "The White House",
    longitude: 7.095993,
    latitude: 125.614835,
    logo_url: "",
    address: "Camella Northpoint, J.P. Laurel Ave, Buhangin, Dabaw, Lalawigan ng Davao del Sur",
    contact: "(082) 282 4540",
    tags: [
      {
        name: "Chicken",
      },
      {
        name: "Beef"
      }
    ]
  },
  {
    id: 8,
    restaurant_name: "Azon's Boneless Lechon",
    longitude: 7.093443,
    latitude: 125.612745,
    logo_url: "",
    address: "Bajada, Davao City, 8000 Davao del Sur",
    contact: "(082) 224 0944",
    tags: [
      {
        name: "Pork",
      },
      {
        name: "Lechon"
      }
    ]
  },
  {
    id: 9,
    restaurant_name: "Kaizen Davao",
    longitude: 7.082710,
    latitude: 125.611410,
    logo_url: "",
    address: "Poblacion District, Davao City, 8000 Davao del Sur",
    contact: "(082) 298 7342",
    tags: [
      {
        name: "Japanese",
      },
      {
        name: "Sushi"
      },
      {
        name: "Pasta"
      }
    ]
  },
  {
    id: 10,
    restaurant_name: "D Little Dynasty Kitchen",
    longitude: 7.082710,
    latitude: 125.611410,
    logo_url: "",
    address: "Door 19 & 20, Plaza del Carmen, Loyola St, Bo. Obrero, Davao City, 8000 Davao del Sur",
    contact: "(082) 224 0119",
    tags: [
      {
        name: "Chicken",
      },
      {
        name: "Pork"
      }
    ]
  },
  {
    id: 11,
    restaurant_name: "Dimyum Seafood Restaurant",
    longitude: 7.082696,
    latitude: 125.614460,
    logo_url: "",
    address: "Door 5, Belles Apartment, P. Sobrecarey St, Poblacion District, Davao City, 8000 Davao del Sur",
    contact: "(082) 324 3428",
    tags: [
      {
        name: "Shrimp",
      },
      {
        name: "Crab"
      }
    ]
  }
]


export default data